/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../api/types.generated";
export type GetWalletUrlsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetWalletUrlsQuery = {
  me: Pick<Types.User, "apple_wallet_url" | "google_wallet_url">;
};

export const GetWalletUrlsDocument = gql`
  query GetWalletUrls {
    me {
      apple_wallet_url
      google_wallet_url
    }
  }
`;

/**
 * __useGetWalletUrlsQuery__
 *
 * To run a query within a React component, call `useGetWalletUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletUrlsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWalletUrlsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetWalletUrlsQuery,
    GetWalletUrlsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetWalletUrlsQuery,
    GetWalletUrlsQueryVariables
  >(GetWalletUrlsDocument, baseOptions);
}
export function useGetWalletUrlsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetWalletUrlsQuery,
    GetWalletUrlsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetWalletUrlsQuery,
    GetWalletUrlsQueryVariables
  >(GetWalletUrlsDocument, baseOptions);
}
export type GetWalletUrlsQueryHookResult = ReturnType<
  typeof useGetWalletUrlsQuery
>;
export type GetWalletUrlsLazyQueryHookResult = ReturnType<
  typeof useGetWalletUrlsLazyQuery
>;
export type GetWalletUrlsQueryResult = ApolloReactCommon.QueryResult<
  GetWalletUrlsQuery,
  GetWalletUrlsQueryVariables
>;
